import { ResponseError } from '../../errors';
import { IApplicationContext } from '../../types/applicationContext';
import { fetchGetMeta, TGetMetaRequest, TGetMetaResponse } from 'shared/repositories/search-offers-index/v2/get-meta';
import { ISearchMeta } from 'shared/types/searchMeta';

const DOMAIN = 'critical.meta';

export async function fetchSearchMeta(
  { httpApi, logger, telemetry }: IApplicationContext,
  parameters: TGetMetaRequest,
): Promise<ISearchMeta | null> {
  const startTime = Date.now();

  try {
    telemetry.increment('meta.request');

    const searchMeta: TGetMetaResponse = await fetchGetMeta({
      httpApi,
      parameters,
    });

    if (searchMeta.statusCode !== 200) {
      throw new ResponseError({
        domain: DOMAIN,
        message: searchMeta.response.message || '',
        details: {
          error: JSON.stringify(searchMeta.response.errors),
        },
      });
    }

    telemetry.increment('meta.response.success');
    telemetry.timing('meta.responseTime', Date.now() - startTime);

    return searchMeta.response.data;
  } catch (e) {
    telemetry.increment('meta.response.error');

    logger.error(
      {
        ...e,
        domain: DOMAIN,
        details: {
          ...e.details,
          microserviceName: 'search-offers-index',
          pathApi: '/public/v2/get-meta/',
          parameters: JSON.stringify(parameters),
        },
      },
      { degradation: 'Запрос меты' },
    );

    return null;
  }
}
